import { Attributes, List, LookupBase } from '@singularsystems/neo-core';
import SurveyParticipantDocumentLookup from './SurveyParticipantDocumentLookup';

export default class SurveyParticipantLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly surveyParticipantId: number = 0;

    public readonly documents = new List(SurveyParticipantDocumentLookup);

    @Attributes.Nullable()
    public readonly questionnaireId: number | null = null;

    @Attributes.Nullable()
    public readonly questionnaireAnsweredId: number | null = null;

    // Client only properties / methods
}